import { IconProps } from "./types";

export default function IcoChild({
	color = "#6B7280",
	width = "11",
	height = "16"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 11 16"
			fill="none"
		>
			<g clipPath="url(#clip0_650_2226)">
				<path
					d="M3.85985 2C3.85985 1.46957 4.07056 0.960859 4.44563 0.585786C4.8207 0.210714 5.32941 0 5.85985 0C6.39028 0 6.89899 0.210714 7.27406 0.585786C7.64913 0.960859 7.85985 1.46957 7.85985 2C7.85985 2.53043 7.64913 3.03914 7.27406 3.41421C6.89899 3.78929 6.39028 4 5.85985 4C5.32941 4 4.8207 3.78929 4.44563 3.41421C4.07056 3.03914 3.85985 2.53043 3.85985 2ZM5.35985 12V15C5.35985 15.5531 4.91297 16 4.35985 16C3.80672 16 3.35985 15.5531 3.35985 15V8.99375L2.70672 10.0312C2.41297 10.5 1.79422 10.6375 1.3286 10.3438C0.86297 10.05 0.71922 9.43437 1.01297 8.96875L2.25985 6.99062C3.03797 5.75 4.39735 5 5.85985 5C7.32235 5 8.68172 5.75 9.45985 6.9875L10.7067 8.96875C11.0005 9.4375 10.8598 10.0531 10.3942 10.3469C9.9286 10.6406 9.30984 10.5 9.0161 10.0344L8.35985 8.99375V15C8.35985 15.5531 7.91297 16 7.35985 16C6.80672 16 6.35985 15.5531 6.35985 15V12H5.35985Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_650_2226">
					<path d="M0.859375 0H10.8594V16H0.859375V0Z" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
